// GEREKLİ IMPORTLAR
import React, { useState, useEffect } from 'react';
import {
  Container, Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Button, Dialog, DialogTitle, DialogContent, CircularProgress, Avatar, IconButton,
  Tooltip, FormControlLabel, Switch, Grid, FormControl, InputLabel, Select, MenuItem, TextField, DialogActions,
  Chip, Divider, Alert
} from '@mui/material';
import { Visibility as VisibilityIcon, Close as CloseIcon, AddTask } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { API_ENDPOINTS } from '../../config/api';
import { useAuth } from '../../contexts/AuthContext';
import FileExplorer from '../../components/common/FileExplorer';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [driveDialogOpen, setDriveDialogOpen] = useState(false);
  const [loadingDrive, setLoadingDrive] = useState(false);
  const { user } = useAuth();
  const [showAllFiles, setShowAllFiles] = useState(false);
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);

  useEffect(() => {
    if (user && user.email !== 'mertdgn35@gmail.com') {
      window.location.href = '/';
    }
  }, [user]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.users.getAll(), {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
        });
        if (!response.ok) throw new Error('Kullanıcılar alınırken bir hata oluştu');
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const fetchDriveFiles = async (folderId = 'root') => {
    if (!selectedUser) return [];
    try {
      const response = await fetch(API_ENDPOINTS.users.getDriveFiles(selectedUser.id, folderId, showAllFiles), {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });
      if (!response.ok) throw new Error('Google Drive dosyaları alınırken bir hata oluştu');
      const data = await response.json();
      return data;
    } catch (error) {
      toast.error(error.message);
      return [];
    }
  };

  const deleteFolder = async (folderId) => {
    if (!selectedUser) throw new Error('Kullanıcı seçilmedi');
    const response = await fetch(API_ENDPOINTS.users.deleteFolder(selectedUser.id, folderId), {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
    });
    if (!response.ok) throw new Error('Klasör silinirken bir hata oluştu');
    return await response.json();
  };

  const handleToggleAllFiles = (event) => {
    setShowAllFiles(event.target.checked);
  };

  const handleViewDriveFiles = async (userId, userName) => {
    setSelectedUser({ id: userId, name: userName });
    setDriveDialogOpen(true);
    setLoadingDrive(true);
    try {
      const response = await fetch(API_ENDPOINTS.users.getDriveFiles(userId, 'root', showAllFiles), {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });
      if (!response.ok) throw new Error('Google Drive dosyaları alınırken bir hata oluştu');
      const data = await response.json();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoadingDrive(false);
    }
  };

  const handleOpenSubscriptionModal = (user) => {
    setSelectedUser(user);
    setSubscriptionModalOpen(true);
  };

  const handleCloseDriveDialog = () => {
    setDriveDialogOpen(false);
    setSelectedUser(null);
  };

  if (loading) {
    return <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh"><CircularProgress /></Box>;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom>Kullanıcı Yönetimi</Typography>
        <Typography variant="body1" paragraph>Sistemde kayıtlı tüm kullanıcıların listesi aşağıda görüntülenmektedir.</Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Profil</TableCell>
                <TableCell>Ad Soyad</TableCell>
                <TableCell>E-posta</TableCell>
                <TableCell>Kayıt Tarihi</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell><Avatar src={user.profile_picture} alt={user.full_name} /></TableCell>
                  <TableCell>{user.full_name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{new Date(user.created_at).toLocaleString('tr-TR')}</TableCell>
                  <TableCell align="right">
                    <Tooltip title="Google Drive Dosyalarını Görüntüle">
                      <IconButton onClick={() => handleViewDriveFiles(user.id, user.full_name)} color="primary">
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Paket Bilgisi Tanımla">
                      <IconButton onClick={() => handleOpenSubscriptionModal(user)} color="primary">
                        <AddTask />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog open={driveDialogOpen} onClose={handleCloseDriveDialog} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{selectedUser?.name} - Google Drive Dosyaları</Typography>
            <Box display="flex" alignItems="center">
              <FormControlLabel
                control={<Switch checked={showAllFiles} onChange={handleToggleAllFiles} color="primary" />}
                label="Tüm Dosyaları Göster"
              />
              <IconButton onClick={handleCloseDriveDialog}><CloseIcon /></IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          {loadingDrive ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="300px">
              <CircularProgress />
            </Box>
          ) : (
            <FileExplorer fetchFiles={fetchDriveFiles} deleteFolder={deleteFolder} showAllFiles={showAllFiles} />
          )}
        </DialogContent>
      </Dialog>

      <SubscriptionModal
        open={subscriptionModalOpen}
        onClose={() => setSubscriptionModalOpen(false)}
        user={selectedUser}
      />
    </Container>
  );
};

const SubscriptionModal = ({ open, onClose, user }) => {
  const [planId, setPlanId] = useState('');
  const [subscriptionType, setSubscriptionType] = useState('monthly');
  const [startDate, setStartDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState('');
  const [customPrice, setCustomPrice] = useState('');
  const [loading, setLoading] = useState(false);
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
  const [removeAndCancel, setremoveAndCancel] = useState('iptal');

  useEffect(() => {
    const fetchUserSubscriptions = async () => {
      if (!user?.id) return;

      setLoadingSubscriptions(true);
      try {
        const response = await fetch(API_ENDPOINTS.subscription.getUserSubscription(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify({
            userId: user.id,
          })
        });
        const data = await response.json();
        setUserSubscriptions(Array.isArray(data) ? data : [data].filter(Boolean));
      } catch (error) {
        console.log('Abonelikler getirilirken hata:', error);
        toast.error('Abonelikler getirilirken bir hata oluştu');
      } finally {
        setLoadingSubscriptions(false);
      }
    };

    fetchUserSubscriptions();
  }, [user]);

  const getSubscriptionStatus = (subscription) => {
    const endDate = new Date(subscription.end_date);
    const now = new Date();
    const daysLeft = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));

    if (subscription.status == 'cancelled') return { color: '#f44336', text: 'İptal Edilmiş' }; // Kırmızı
    if (daysLeft < 0) return { color: '#f44336', text: 'Süresi Dolmuş' }; // Kırmızı
    if (daysLeft <= 7) return { color: '#ff9800', text: `${daysLeft} Gün Kaldı` }; // Sarı
    return { color: '#4caf50', text: 'Aktif' }; // Yeşil
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      // Geçerli tarih kontrolü
      if (isNaN(date.getTime())) {
        return 'Geçersiz Tarih';
      }
      return format(date, 'dd.MM.yyyy');
    } catch (error) {
      console.error('Tarih formatlanırken hata:', error);
      return 'Geçersiz Tarih';
    }
  };

  useEffect(() => {
    if (subscriptionType === 'monthly') {
      const end = new Date(startDate);
      end.setMonth(end.getMonth() + 1);
      setEndDate(format(end, 'yyyy-MM-dd'));
    } else if (subscriptionType === 'yearly') {
      const end = new Date(startDate);
      end.setFullYear(end.getFullYear() + 1);
      setEndDate(format(end, 'yyyy-MM-dd'));
    }
  }, [startDate, subscriptionType]);

  const handleCancelSubscription = async (subscriptionId) => {
    setremoveAndCancel('iptal')
    setSelectedSubscriptionId(subscriptionId);
    setConfirmDialogOpen(true);
  };
  const handleRemoveSubscription = async (subscriptionId) => {
    setremoveAndCancel('sil')
    setSelectedSubscriptionId(subscriptionId);
    setConfirmDialogOpen(true);
  };

  const handleConfirmCancel = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.subscription.cancel(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({ subscriptionId: selectedSubscriptionId })
      });

      if (!response.ok) throw new Error('İptal işlemi başarısız');
      toast.success('Abonelik başarıyla iptal edildi');
      setUserSubscriptions(prevSubs =>
        prevSubs.map(sub =>
          sub.id === selectedSubscriptionId
            ? { ...sub, status: 'cancelled' }
            : sub
        )
      );
    } catch (error) {
      console.error('Abonelik iptal edilirken hata:', error);
      toast.error('Abonelik iptal edilirken bir hata oluştu');
    } finally {
      setLoading(false);
      setConfirmDialogOpen(false);
    }
  };

  const handleConfirmRemove = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.subscription.remove(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({ subscriptionId: selectedSubscriptionId })
      });

      if (!response.ok) throw new Error('Silme işlemi başarısız');
      toast.success('Abonelik başarıyla silindi');
      setUserSubscriptions(prevSubs =>
        prevSubs.filter(sub => sub.id !== selectedSubscriptionId)
      );
    } catch (error) {
      console.error('Abonelik silinirken hata:', error);
      toast.error('Abonelik silinirken bir hata oluştu');
    } finally {
      setLoading(false);
      setConfirmDialogOpen(false);
    }
  };

  const handleAcceptSubscription = async (selectedSubscriptionId) => {
    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.subscription.accept(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({ subscriptionId: selectedSubscriptionId })
      });

      if (!response.ok) throw new Error('Aktif işlemi başarısız');

      toast.success('Abonelik başarıyla aktif edildi');
      setUserSubscriptions(prevSubs =>
        prevSubs.map(sub =>
          sub.id == selectedSubscriptionId
            ? { ...sub, status: 'active' }
            : sub
        )
      );
    } catch (error) {
      console.error('Abonelik aktif edilirken hata:', error);
      toast.error('Abonelik aktif edilirken bir hata oluştu');
    } finally {
      setLoading(false);
      setConfirmDialogOpen(false);
    }
  };
  

  const handleSave = async () => {
    if (!planId || !startDate || !endDate) {
      toast.error('Lütfen tüm zorunlu alanları doldurun');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(API_ENDPOINTS.subscription.create(user.id), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({
          userId: user.id,
          planId,
          startDate,
          endDate,
          subscriptionType,
          price: customPrice ? parseFloat(customPrice) : 0
        })
      });

      if (!response.ok) throw new Error('Abonelik oluşturulurken bir hata oluştu');

      const newSubscription = await response.json();
      setUserSubscriptions(prev => [...prev, newSubscription]);
      toast.success('Abonelik başarıyla oluşturuldu');
      //onClose();
    } catch (error) {
      console.error('Abonelik oluşturulurken hata:', error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Paket Tanımla - {user?.email}</DialogTitle>
        <DialogContent>
          <Box mb={4}>
            <Typography variant="h6" gutterBottom>Abonelik Geçmişi</Typography>
            {loadingSubscriptions ? (
              <CircularProgress size={24} />
            ) : userSubscriptions.length > 0 ? (
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Paket</TableCell>
                      <TableCell>Başlangıç</TableCell>
                      <TableCell>Bitiş</TableCell>
                      <TableCell>Durum</TableCell>
                      <TableCell>Fiyat</TableCell>
                      <TableCell>İşlem</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {userSubscriptions.map((subscription) => {
                      const status = getSubscriptionStatus(subscription);
                      return (
                        <TableRow key={`subscription-${subscription.id}`}>
                          <TableCell>{subscription.title}</TableCell>
                          <TableCell>
                            {formatDate(subscription.start_date)}
                          </TableCell>
                          <TableCell>
                            {formatDate(subscription.end_date)}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={status.text}
                              size="small"
                              style={{
                                backgroundColor: status.color,
                                color: 'white'
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {subscription.price_paid
                              ? subscription.price_paid.toLocaleString('tr-TR', {
                                style: 'currency',
                                currency: 'TRY'
                              }) + ' TL'
                              : '—'}
                          </TableCell>
                          <TableCell>
                            {subscription.status === 'active' && (
                              <Button
                                size="small"
                                color="error"
                                onClick={() => handleCancelSubscription(subscription.id)}
                                disabled={loading}
                              >
                                İptal Et
                              </Button>
                            )}
                            {subscription.status === 'cancelled' && (
                              <Button
                                size="small"
                                color="error"
                                onClick={() => handleRemoveSubscription(subscription.id)}
                                disabled={loading}
                              >
                                Sil
                              </Button>
                            )}
                            {subscription.status === 'cancelled' && (
                              <Button
                                size="small"
                                color="success"
                                onClick={() => handleAcceptSubscription(subscription.id)}
                                disabled={loading}
                              >
                                Aktif Et
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Alert severity="info">Henüz bir abonelik tanımlanmamış.</Alert>
            )}
          </Box>
        </DialogContent>

        <Divider sx={{ my: 3 }} />
        {/* Mevcut form alanları buraya gelecek */}
        <DialogContent>
          <Typography variant="h6" gutterBottom>Yeni Abonelik Tanımla</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Paket</InputLabel>
                <Select value={planId} onChange={(e) => setPlanId(e.target.value)} required>
                  <MenuItem value="1">Ücretsiz</MenuItem>
                  <MenuItem value="2">Standart</MenuItem>
                  <MenuItem value="3">Pro</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Abonelik Türü</InputLabel>
                <Select value={subscriptionType} onChange={(e) => setSubscriptionType(e.target.value)} required>
                  <MenuItem value="monthly">Aylık</MenuItem>
                  <MenuItem value="yearly">Yıllık</MenuItem>
                  <MenuItem value="custom">Özel Tarih</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth label="Başlangıç Tarihi" type="date" value={startDate}
                onChange={(e) => setStartDate(e.target.value)} InputLabelProps={{ shrink: true }} required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth label="Bitiş Tarihi" type="date" value={endDate}
                onChange={(e) => setEndDate(e.target.value)} InputLabelProps={{ shrink: true }}
                required disabled={subscriptionType !== 'custom'}
              />
            </Grid>
            {subscriptionType === 'custom' && (
              <Grid item xs={12}>
                <TextField
                  fullWidth label="Özel Fiyat (TL)" type="number" value={customPrice}
                  onChange={(e) => setCustomPrice(e.target.value)} required
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>İptal</Button>
          <Button onClick={handleSave} variant="contained" color="primary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Kaydet'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
        <DialogTitle>Abonelik {removeAndCancel == 'sil'? 'Silme':'İptali'}</DialogTitle>
        <DialogContent>
          <Typography>Bu aboneliği {removeAndCancel == 'sil'? 'silmek':'iptal etmek'} istediğinize emin misiniz?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)}>Vazgeç</Button>
          <Button onClick={removeAndCancel == 'sil'? handleConfirmRemove:handleConfirmCancel} color="error" variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'İşlemi Tamamla'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Users;
